import React from 'react';
import { formatV2Timestamp, parseV2Timestamp } from '../../utils/v2DateTime';

/** v2 API의 UTC 시각을 한국 시각으로 표시하는 공통 <time>. 문장 속 시각은 formatV2Timestamp를 쓴다. */
function V2DateTime({ value, format = 'dateTime', prefix = '', fallback = null, title, ...props }) {
  const date = parseV2Timestamp(value);
  if (!date) return fallback;
  const text = formatV2Timestamp(date, format);
  return (
    <time dateTime={date.toISOString()} title={title ?? `${text} (한국 시간)`} {...props}>
      {prefix}{text}
    </time>
  );
}

export default V2DateTime;
